<template>
    <div class="badgeSetup dashboard_root">
        <h2>Badge Setup</h2>
        <div class="badgeSetup_specifications">
            <div class="badgeSetup_specifications_select">
                <div class="badgeSetup_specifications_select_radio-select">
                    <p>Select badge color:</p>
                    <div class="badgeSetup_specifications_select_radio-select_inner">
                        <div class="badgeSetup_specifications_select_radio-select_inner-item">
                            <input checked @click="setTheme('light')" name="theme" id="dark_theme" type="radio" />

                            &nbsp;
                            <label for="light_theme">Light</label>
                        </div>
                        <div class="badgeSetup_specifications_select_radio-select_inner-item">
                            <input @click="setTheme('dark')" name="theme" id="light_theme" type="radio" />
                            &nbsp;
                            <label for="dark_theme">dark</label>
                        </div>
                    </div>
                </div>
                <div class="badgeSetup_specifications_select_range">
                    <p>Adjust badge size:</p>
                    <input @input="resizeImg" type="range" min="15" max="40" v-model="imgSize" />
                </div>
            </div>
            <div ref="iframe" class="iframe_view">
                <div class="iframe_view_img">
                    <img :width="imgSize * 10" :src="imgResource" alt="" />
                </div>
            </div>
        </div>
        <div class="badgeSetup_copy-code">
            <p>Copy and paste this code below to embed the badge in your webpage</p>
            <div class="badgeSetup_copy-code_inner">
                <code class="language-markup">
                    {{ badgeCode }}
                </code>
                <span @click="$store.dispatch('copyToClipBoard', badgeCode)" class="copy_icon_svg"><i class="ri-clipboard-line"></i></span>
            </div>
            <div class="btn btn_color btn_long">
                <button @click="$store.dispatch('copyToClipBoard', badgeCode)">Copy Code</button>
            </div>
        </div>
    </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import Prism from "prismjs";
import "prismjs/themes/prism.css";
const route = useRoute();
const imgSize = ref(30);
const baseUri = ref("https://rivet.cloud");
const theme = ref("light");
const iframe = ref(null);
const imgResource = ref(`${baseUri.value}/api/badge/${route.query.bg_code}/${theme.value}-bg.svg`);
const badgeCode = ref(
    `<div><a href="https://rivet.cloud?badge=${route.query.bg_code}" target="_blank"><img width="${imgSize.value * 10}" src="${
        imgResource.value
    }" alt="built with rivet.cloud"/></a></div>`
);

const resizeImg = () => {
    badgeCode.value = `<div><a href="https://rivet.cloud?badge=${route.query.bg_code}" target="_blank"><img width="${imgSize.value * 10}" src="${
        imgResource.value
    }" alt="built with rivet.cloud"/></a></div>`;
};

const setTheme = (a) => {
    if (a === theme.value) {
        return null;
    } else {
        theme.value = a;
        imgResource.value = `${baseUri.value}/api/badge/${route.query.bg_code}/${theme.value}-bg.svg`;
        iframe.value.classList.toggle("light");
    }
};

onMounted(() => {
    Prism.highlightAll();
});
</script>
<style lang="scss" scoped>
.badgeSetup {
    @include flex_col(2rem);
    &_specifications {
        @include flex(space-between, flex-start, 0 1rem);
        @include media("<=tablet") {
            @include flex_col(1rem);
        }
        &_select {
            @include flex_col(1.4rem);
            @include media("<=tablet") {
                width: 100%;
            }
            &_radio-select {
                @include flex_col(1rem);
                &_inner {
                    @include flex(flex-start, center, 0 2rem);
                    label {
                        font-weight: 500;
                    }
                    input {
                        cursor: pointer;
                    }
                }
            }
            &_range {
                input[type="range"] {
                    -webkit-appearance: none;
                    margin: 18px 0;
                    width: 20rem;
                    @include media("<=tablet") {
                        width: 100%;
                    }
                    &::-webkit-slider-runnable-track {
                        height: 8.4px;
                        cursor: pointer;
                        background: $fadegrey;
                        border-radius: 3px;
                        border: 1px solid #010101;
                    }
                    &::-webkit-slider-thumb {
                        height: 20px;
                        width: 16px;
                        border-radius: 3px;
                        background: $blue;
                        cursor: pointer;
                        -webkit-appearance: none;
                        margin-top: -7px;
                    }
                }
            }
        }
        .iframe_view {
            overflow: hidden;
            width: 45%;
            height: 13rem;
            background: white;
            padding: 1rem;
            background: $blue;
            border-radius: 0.5rem;
            border: 1px solid black;
            @include flex(center, center, 0);
            @include media("<=tablet") {
                width: 100%;
            }
            &_img {
                overflow: hidden;
            }
        }
        .light {
            background: white !important;
        }
    }
    &_copy-code {
        @include flex_col(1rem);
        code {
            padding: 1rem 1.5rem;
            white-space: nowrap;
            overflow: scroll;
        }
        &_inner {
            @include flex(flex-start, center, 0 1rem);
            span {
                display: block;
                padding: 0.5rem 1rem;
                height: 3rem;
                border: 1px solid rgb(0, 0, 0);
                @include media("<=tablet") {
                    display: none;
                }
            }
        }
        .btn {
            display: none;
            @include media("<=tablet") {
                display: block;
            }
        }
    }
}
</style>
